import store from '@/store'
import Configuration from '@/agilis/util/Configuration'
import TreeEditorV2 from '@/agilis/components/TreeEditorV2/TreeEditorV2.vue'

export default {
  name: 'PlaygroundTreeEditorV2',

  components: {
    TreeEditorV2
  },

  data () {
    return {
      documentId: null
    }
  },

  computed: {
    applicationId () {
      return 'playground'
    },

    workspaceId () {
      return 'treeEditorV2'
    },

    documents () {
      return Configuration.document.getAvailableDocuments(this.applicationId, this.workspaceId)
    },

    document () {
      return Configuration.document.getDocument(this.applicationId, this.documentId)
    },

    schema () {
      return Configuration.document.getDocumentSchema(this.applicationId, this.document)
    }
  },

  watch: {
    documentId () {
      store.commit('contextStore/setSelectedContext', {
        applicationId: this.applicationId,
        workspaceId: this.workspaceId,
        trackerTypeId: this.documentId
      })
    }
  }

}
